import script from "./cardMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./cardMobile.vue?vue&type=script&setup=true&lang=js"

import "./cardMobile.vue?vue&type=style&index=0&id=a0cade38&scoped=true&lang=less"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0cade38"]])

export default __exports__